import React, { useEffect, useState } from "react";
import { servicesSec } from "./data";
import { useMediaQuery } from "react-responsive";
import "./servicesSec.css";
import { Link } from "react-router-dom";

const ServicesSec = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % servicesSec.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  const handleClick = (index, interval) => {
    setActiveIndex(index);
    clearInterval(interval);
    window.scrollTo(0, 0);
  };

  function highlightWords(text, wordsToBold) {
    const regex = new RegExp(`(${wordsToBold.join("|")})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, index) =>
      wordsToBold.includes(part) ? (
        <span key={index} className="highlighted-word">
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  return (
    <section className="servicesSec">
      {isMobile ? (
        <div className="mobile-version">
          <div className="servicesSec-container">
            <div className="servicesSec-left">
              <div className="text-wrapper">
                <h1>
                  Step Up To Explore Our
                  <span className="title-word">Services</span>
                </h1>
                <p>
                  Choose from our comprehensive packages or select individual
                  services to suit your needs. Browse through options like
                  <span className="desc-word"> Social Media Management </span>,
                  <span className="desc-word">Content Creation </span>,
                  <span className="desc-word">Video Editing </span>,
                  <span className="desc-word">Graphic Design </span>,
                  <span className="desc-word">SEO </span>,
                  <span className="desc-word">UI/UX </span>, and more—each
                  crafted to elevate your brand and engage your target audience
                  effectively.
                </p>
              </div>
            </div>
            <div className="servicesSec-right">
              {servicesSec.map((service, index) => (
                <Link to="/creativeBundle" key={service.id}>
                  <div
                    className={`box ${activeIndex === index ? "active" : ""}`}
                    onClick={() => handleClick(index)}
                  >
                    <div className="headline">
                      <h2>{service.title}</h2>
                      <div className="svg-box">{service.svg}</div>
                    </div>
                    <p>
                      {highlightWords(service.description, service.boldWords)}
                    </p>
                    <p className="discount">
                      Save up to <span className="desc-word">10</span>% by
                      choosing this bundle!
                    </p>
                  </div>
                </Link>
              ))}
              <Link to="/services" onClick={handleClick}>
                <button className="btn">Discover Our Services</button>
              </Link>
            </div>
          </div>
        </div>
      ) : (
        <div className="servicesSec-container">
          <div className="servicesSec-left">
            <div className="text-wrapper">
              <h1>
                Step Up To Explore Our
                <span className="title-word">Services</span>
              </h1>
              <p>
                Choose from our comprehensive packages or select individual
                services to suit your needs. Browse through options like
                <span className="desc-word"> Social Media Management </span>,
                <span className="desc-word">Content Creation </span>,
                <span className="desc-word">Video Editing </span>,
                <span className="desc-word">Graphic Design </span>,
                <span className="desc-word">SEO </span>,
                <span className="desc-word">UI/UX </span>, and more—each crafted
                to elevate your brand and engage your target audience
                effectively.
              </p>
              <Link to="/services" onClick={handleClick}>
                <button className="btn">Discover Our Services</button>
              </Link>
            </div>
          </div>
          <div className="servicesSec-right">
            {servicesSec.map((service, index) => (
              <Link to="/creativeBundle" key={service.id}>
                <div
                  className={`box ${activeIndex === index ? "active" : ""}`}
                  onClick={() => handleClick(index)}
                >
                  <div className="headline">
                    <h2>{service.title}</h2>
                    <div className="svg-box">{service.svg}</div>
                  </div>
                  <p>
                    {highlightWords(service.description, service.boldWords)}
                  </p>
                  <p className="discount">
                    Save up to <span className="desc-word">10</span>% by
                    choosing this bundle!
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default ServicesSec;
